import { css, SimpleInterpolation } from "styled-components";
import { BreakpointProps, getBreakpointOffset } from "./breakpoints";

export const mediaQuery =
  (props: BreakpointProps) =>
  (strings: TemplateStringsArray, ...interpolations: SimpleInterpolation[]) => {
    const bp = getBreakpointOffset(props);

    if (bp.min && bp.max) {
      return css`
        @media (min-width: ${bp.min}px) and (max-width: ${bp.max}px) {
          ${css(strings, ...interpolations)};
        }
      `;
    } else if (bp.min) {
      return css`
        @media (min-width: ${bp.min}px) {
          ${css(strings, ...interpolations)};
        }
      `;
    } else {
      return css`
        @media (max-width: ${bp.max}px) {
          ${css(strings, ...interpolations)};
        }
      `;
    }
  };
